import {PaneComponent, PaneComponentConfig} from "./pane_component";
import {PrimaryPaneBodyComponent, PrimaryPaneBodyComponentConfig} from "./primary_pane_body_component";
import {NavBarComponent, NavBarComponentConfig} from "./nav_bar_component";

export const PrimaryPaneComponentConfig = {
    baseHtmlClass: 'nav__pane--primary',
    selector: '.nav__pane--primary',

    bodyContentScrolledModifier: 'scrolled'
};

export class PrimaryPaneComponent extends PaneComponent {

    constructor(id_or_element, primaryPane) {
        const config = PaneComponentConfig // Note that we supply the PaneComponentConfig (not the PrimaryPaneComponentConfig)!
        super(id_or_element, primaryPane, config);

        this.navBarComponent = getNavBarComponent(this);

        this.hasBodyContentScrolled = false;
        this.primaryPaneBodyComponent = getPrimaryPaneBodyComponent(this);
        if (this.navBarComponent) {
            const navBarHeight = this.navBarComponent.element.offsetHeight;
            this.primaryPaneBodyComponent.adjustScrolledThreshold(-navBarHeight);
        }
    }

    setBodyContentScrolled(value) {
        // For performance, only set and render when the value actually changes.
        if (this.hasBodyContentScrolled !== value) {
            this.hasBodyContentScrolled = value;
            if (this.navBarComponent) {
                this.navBarComponent.setBodyContentScrolled(value)
            }
            this.render();
        }
    }

    render() {
        this.swapHtmlClassStates(this.pane.readInternalStateValue('focused'), 'focused', 'blurred');
        this.swapHtmlClassStates(this.pane.readInternalStateValue('active'), 'active', 'inactive');
        this.conditionallySetHtmlClassState(this.hasBodyContentScrolled, PrimaryPaneComponentConfig.bodyContentScrolledModifier);
    }
}

function getNavBarComponent(primaryPaneComponent) {
    let element = primaryPaneComponent.element.querySelector(NavBarComponentConfig.selector);
    if (element) return new NavBarComponent(element, primaryPaneComponent);
}

function getPrimaryPaneBodyComponent(primaryPaneComponent) {
    let element = primaryPaneComponent.element.querySelector(PrimaryPaneBodyComponentConfig.selector);
    if (element) return new PrimaryPaneBodyComponent(element, primaryPaneComponent);
}